module.exports = __webpack_public_path__ + "img/a04706317bbbf7a30d5bab2a94644b7.d3c41625.jpg";